import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { IStatus } from "../../models/BaseModel";

export interface IOpenForm {
    open: boolean,
    singleData: IStatus
}

export const Status = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    return (
        <>
            {(hasPermission("Status", "Add") || hasPermission("Status", "Edit")) && <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
